import PortfolioPlaylistEditor from '../PortfolioPlaylistEditor'
import PortfolioContentEditor from '../PortfolioContentEditor'
import DndProviderWrapper from '../../../components/DndProviderWrapper/DndProviderWrapper'
import getPortfolioStyles from '../../../utils/getPortfolioStyles'
import { useEffect, useRef, useState } from 'react'

const TemplateProfileRight = ({ values, onChange, isPreview }) => {
  const playlistStyles = getPortfolioStyles(values?.pageData?.playlistRegion)
  const contentStyles = getPortfolioStyles(values?.pageData?.contentRegion)
  const [rerenderKey, setReRenderKey] = useState(Math.random())
  const [secondKey, setSecondKey] = useState(Math.random())
  useEffect(() => {
    setReRenderKey(Math.random())
  }, [values.template])

  useEffect(() => {
    setSecondKey(Math.random())
  }, [rerenderKey])

  return (
    <div className="flex w-full h-full template-container">
      <div className="p-4 pr-2 flex-fill" style={playlistStyles}>
        <DndProviderWrapper className="w-full h-full flex flex-col">
          <PortfolioPlaylistEditor
            values={values}
            onChange={onChange}
            isPreview={isPreview}
          />
        </DndProviderWrapper>
      </div>
      <div className="p-4 pl-2 flex-fill max-w-[40%]" style={contentStyles}>
        <PortfolioContentEditor
          values={values}
          onChange={onChange}
          region="contentRegion"
          isPreview={isPreview}
        />
      </div>
    </div>
  )
}

export default TemplateProfileRight
